import React from 'react';
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl';

import { LinkButton } from '../Button';
import { Moon } from '../../svgs/Moon';
import { Moons } from '../../svgs/Moons';

export const SleepDeprivation = () => {
  const { formatMessage } = useIntl();

  return (
    <section className="w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-32 lg:py-84 lg:pb-48 flex lg:flex-col lg:items-center relative z-10">
      <div className="hidden md:block lg:absolute flex-1 left-0 top-0 lg:w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 lg:pt-32">
        <Moon width={520} className="lg:w-auto w-full" />
      </div>
      <div className="flex flex-col lg:items-center relative flex-1 md:pt-32 lg:pt-0">
        <Moons className="w-full md:hidden mb-4" />
        <FormattedMessage id="sleep.title">
          {(text) => (
            <h2
              className="text-2xl md:text-4xl lg:text-6xl font-heading font-bold mb-4 md:mb-6 lg:mb-12"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </FormattedMessage>
        <div className="md:text-lg font-medium flex">
          <div className="hidden lg:block lg:w-96 flex-1"></div>
          <div className="lg:w-96 flex-1 flex flex-col items-start">
            <p className="mb-4">{formatMessage({ id: 'sleep.p1' })}</p>
            <p className="mb-4">{formatMessage({ id: 'sleep.p2' })}</p>
            <p className="mb-6">{formatMessage({ id: 'sleep.p3' })}</p>
            <LinkButton href="/screens">{formatMessage({ id: 'sleep.cta' })}</LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};
